// constants.js

export const groupingTypes = ['BA', 'PU', 'EN', 'HI', 'AA'];

export const typeFilter = [
	{ label: "Current Balance", value: "CB" },
	{ label: "Prior Day Balance", value: "PB" },
	{ label: "Prior Day Transactions", value: "1T" },
	{ label: "MTD Transactions", value: "MT" },
	{ label: "Prior Month Transactions", value: "PT" },
	{ label: "Custom Period Transactions", value: "CT" },
	{ label: "Bank Account", value: "BA" },
	{ label: "Balance Diff (1 day)", value: "B1" },
	{ label: "Balance Diff (1 week)", value: "B7" },
	{ label: "Balance Breakdown Report", value: "BB" },
	{ label: "Balance as of Date", value: "BD" },
	{ label: "Prior Month End Balance", value: "BM" },
	{ label: "Short Term Forecast", value: "SF" },
  { label: 'Prior Day Aggregated Transactions', value: 'TP' },
  { label: 'Past 7 Days Aggregated Transactions', value: '7T' },
  { label: 'Month to Date Aggregated Transactions', value: 'TM' },
  { label: 'Custom Period Aggregated Transactions', value: 'CP' },
];

export const groupingTypeFilter = [
	{ label: "Bank", value: "BA" },
	{ label: "Entity", value: "EN" },
	{ label: "All Accounts", value: "AA" },
	{ label: "Hierarchy", value: "HI" },
	{ label: "Purpose", value: "PU" },
];

export const transactionGroupingTypeFilter = [
	{ label: "Original Completed Transactions", value: "OC" },
	{ label: "Edited Completed Transactions", value: "EC" },
	{ label: "Pending Transactions", value: "PG" },
	{ label: "Canceled Transactions", value: "CD" },
];

export const groupKeyToLabelMap = {
	EN: "Entity",
	BA: "Bank",
	CO: "Collection",
	AS: "Asset",
	AA: "All Accounts",
	HI: "Hierarchy",
	PU: "Purpose",
};

export const transactionGroupKeyToLabelMap = {
	OC: "Original Completed Transactions",
	EC: "Edited Completed Transactions",
	PG: "Pending Transactions",
	CD: "Canceled Transactions",
};

export const isTransactionReportType = {
	"Prior Day Transactions": true,
	"MTD Transactions": true,
	"Prior Month Transactions": true,
	"Custom Period Transactions": true,
	"1T": true,
	MT: true,
	PT: true,
	CT: true,
};

export const blockBai2Types = [
	"Bank Account",
	"Balance Diff (1 day)",
	"Balance Diff (1 week)",
	"Balance Breakdown Report",
	"Prior Month End Balance",
	"Balance as of Date",
	"Short Term Forecast",
  "Prior Day Aggregated Transactions",
  "Past 7 Days Aggregated Transactions",
  "Month to Date Aggregated Transactions",
  "Custom Period Aggregated Transactions",
];

export const customDateRangeReportTypes = [
  "CT",
  "CP",
]

export const customReportCalcTypes = [
  { value: 'CB', label: 'Closing Balance' },
  { value: 'OB', label: 'Opening Balance' },
  { value: 'NT', label: 'Net Transactions' },
  { value: 'IF', label: 'Inflows' },
  { value: 'OF', label: 'Outflows' },
  { value: 'BC', label: 'Balance Change' },
]

export const customReportEndDateAdjustments = [
  { value: 'SD', label: 'Same day' },
  { value: 'PD', label: 'Prior day' },
  { value: 'PEOW', label: 'Prior end of week' },
  { value: 'PEOM', label: 'Prior end of month' },
  { value: 'PEOQ', label: 'Prior end of quarter' },
  { value: 'PEOY', label: 'Prior end of year' },
]

export const customReportStartDateAdjustments = [
  { value: 'WTD', label: 'Week to date' },
  { value: 'MTD', label: 'Month to date' },
  { value: 'QTD', label: 'Quarter to date' },
  { value: 'YTD', label: 'Year to date' },
  { value: 'LXD', label: 'Last x days' },
  { value: 'LXW', label: 'Last x weeks' },
  { value: 'LXM', label: 'Last x months' },
]
